"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var theme = require("./theme.scss");
var moment = require("moment");
var _ = require("lodash");
var avatar_1 = require("@vidazoo/ui/lib/components/avatar");
var HistoryLogDiffItem_1 = require("./HistoryLogDiffItem");
var lib_1 = require("../../lib");
var ActionType;
(function (ActionType) {
    ActionType["CREATE"] = "create";
    ActionType["UPDATE"] = "update";
    ActionType["DELETE"] = "delete";
})(ActionType || (ActionType = {}));
var actionDescriptionFactory = function (actionType) {
    switch (actionType) {
        case ActionType.CREATE:
            return "created";
        case ActionType.UPDATE:
            return "updated";
        case ActionType.DELETE:
            return "deleted";
    }
};
var HistoryLogItem = /** @class */ (function (_super) {
    tslib_1.__extends(HistoryLogItem, _super);
    function HistoryLogItem(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = { error: false };
        return _this;
    }
    HistoryLogItem.prototype.componentDidCatch = function () {
        this.setState({
            error: true
        });
    };
    Object.defineProperty(HistoryLogItem.prototype, "authorName", {
        get: function () {
            var item = this.props.item;
            return item.auth.firstName + " " + item.auth.lastName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryLogItem.prototype, "authorAvatarUrl", {
        get: function () {
            var item = this.props.item;
            return lib_1.gravatar.getUrl(item.auth.email);
        },
        enumerable: true,
        configurable: true
    });
    HistoryLogItem.prototype.render = function () {
        var item = this.props.item;
        var error = this.state.error;
        if (error) {
            return (React.createElement("div", { className: theme.item }, "Failed to parse history log item."));
        }
        var authorClasses = classnames(theme.author, theme[item.action]);
        var date = moment(+item.date);
        var since = date.fromNow();
        var fullDate = date.format("DD-MM-YY HH:mm");
        return (React.createElement("div", { className: theme.item },
            React.createElement("div", { className: theme.header },
                React.createElement(avatar_1.Avatar, { className: theme.avatar, imageUrl: this.authorAvatarUrl, small: true }),
                React.createElement("div", { className: theme.content },
                    React.createElement("div", { className: theme.title },
                        React.createElement("div", { className: authorClasses }, this.authorName),
                        React.createElement("div", { className: theme.action },
                            actionDescriptionFactory(item.action),
                            " this item")),
                    React.createElement("span", { className: theme.date },
                        React.createElement("span", null, since + " (" + fullDate + ")")))),
            _.map(item.diff, function (data, key) { return React.createElement(HistoryLogDiffItem_1.default, { key: key, itemKey: key, data: data }); })));
    };
    HistoryLogItem.defaultProps = {};
    return HistoryLogItem;
}(React.Component));
exports.default = HistoryLogItem;
